import React from "react"
import tw from "twin.macro"
import { Search } from "react-feather"

interface Props {
  className?: string

  [x: string]: any
}

export const SearchBar = React.forwardRef<HTMLInputElement, Props>(
  ({ className, ...props }, ref) => {
    return (
      <SearchBarStyles.Wrapper className={className}>
        <SearchBarStyles.Input
          {...props}
          ref={ref}
          type="search"
          placeholder="What are you looking for?"
          aria-label="Search"
          autocomplete="off"
        />
        <SearchBarStyles.Button aria-label="search">
          <SearchBarStyles.Icon />
        </SearchBarStyles.Button>
      </SearchBarStyles.Wrapper>
    )
  }
)

const SearchBarStyles = {
  Wrapper: tw.div`relative w-full text-gray-600`,
  Input: tw.input`w-full h-10 pl-5 pr-10 text-sm bg-white rounded-lg focus:outline-none`,
  Button: tw.button`absolute top-0 right-0 mt-3 mr-4 focus:outline-none`,
  Icon: tw(Search)`h-4 w-4`,
}
